// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"16":"expresseditor","478":"volunteerManagment","755":"kiosk","986":"housekeeping"}[chunkId] + "." + {"16":"e36b43eed211bca83f4c","478":"60b3b0cae9f65f7b2493","755":"8bc1621549988be56181","986":"2422451ed48b574fb7b6"}[chunkId] + ".css";
};